import pick from 'lodash/pick';
import pickBy from 'lodash/pickBy';
import find from 'lodash/find';

import { DateTimeHelper } from '@/util/date-time-helper';

export function mergeVacancies(vacancyFields, candidateFields) {
  const whitelist = ['deadline', 'applicants_to_hire', 'hide-vacancy-deadline', 'position_shtat'];
  return {
    ...vacancyFields,
    ...pick(candidateFields, whitelist)
  };
}

export function getChildVacancyByUniqueFields(vacancies, values, multivacancyFields) {
  const uniqFieldKeys = Object.keys(pickBy(multivacancyFields, (field) => field.unique));
  return find(vacancies, pick(values, uniqFieldKeys));
}

export function getVacancyFields(vacancyRequest, schema) {
  const keys = ['money', 'company', 'account_division', 'account_region', 'applicants_to_hire'];
  const { id, values } = vacancyRequest;
  const fixDate = (date) => {
    if (date) {
      try {
        return DateTimeHelper.parse({ date }).toServerFormat({
          includeTime: false
        });
      } catch {
        return DateTimeHelper.parseLegacyDate({ date }).toServerFormat({
          includeTime: false
        });
      }
    }
  };

  const fieldValues = Object.entries(schema).reduce(
    (acc, [schemaKey, schemaValue]) => {
      if (keys.includes(schemaValue.key)) {
        acc[schemaValue.key] = values[schemaKey];
      }
      if (schemaValue.vacancy_field) {
        acc[schemaValue.vacancy_field] = values[schemaKey];
        if (schemaValue.type === 'date') {
          acc[schemaValue.vacancy_field] = fixDate(acc[schemaValue.vacancy_field]);
        }
      }
      if (schemaValue.fields) {
        Object.entries(schemaValue.fields).forEach((subKey, subValue) => {
          if (subValue.vacancy_field) {
            acc[subValue.vacancy_field] = values[schemaKey][subKey];
            if (subValue.type === 'date') {
              acc[subValue.vacancy_field] = fixDate(acc[subValue.vacancy_field]);
            }
          }
        });
      }
      return acc;
    },
    { position: vacancyRequest.position }
  );

  return {
    ...fieldValues,
    account_division: fieldValues.account_division
      ? parseInt(fieldValues.account_division, 10)
      : null,
    vacancy_request: id
  };
}
